<script setup lang="ts">
type Props = {
  text: string;
  title?: string;
  yesBtnLabel: string;
  noBtnLabel: string;
};

type Emits = {
  (e: 'dialogConfirmation'): void;
  (e: 'closeDialog'): void;
};

defineProps<Props>();
const emit = defineEmits<Emits>();

const handleConfirmation = () => emit('dialogConfirmation');
const handleClose = () => emit('closeDialog');
</script>

<template>
  <v-dialog max-width="580">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center text-on-surface">
        <div v-if="title" class="text-h6 text-wrap ps-2">
          {{ title }}
        </div>
        <v-spacer v-else></v-spacer>
        <v-btn icon="mdi-close" variant="text" @click="handleClose"></v-btn>
      </v-card-title>

      <v-divider v-if="title" class=""></v-divider>

      <v-card-text class="text-on-surface">
        <span>{{ text }}</span>
      </v-card-text>

      <v-card-actions class="d-flex justify-end flex-wrap-reverse px-6 pb-4 ga-3">
        <v-btn size="large" variant="outlined" :text="noBtnLabel" @click="handleClose" class="px-4" />

        <v-btn size="large" variant="flat" color="error" :text="yesBtnLabel" @click="handleConfirmation" class="px-4" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss"></style>
